const getZapUrlPathParts = ({ lpAddress }: { lpAddress: string }): string => {
  return `CRO/${lpAddress}`
}

export default getZapUrlPathParts
